var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { style: _vm.s.container }, [
    _c("div", { style: _vm.s.wrapper }, [
      _c("div", { style: _vm.s.title }, [
        _vm._v(_vm._s(_vm.Title)),
        _c("span", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.ShowClose,
              expression: "ShowClose"
            }
          ],
          style: _vm.s.close,
          on: { click: _vm.close }
        })
      ]),
      _c("div", { staticClass: "head" }, [
        _c("img", {
          staticClass: "icon",
          attrs: {
            src:
              _vm.tokenDetail.urlIcon ||
              _vm.token.icon ||
              _vm.getIcon(_vm.token.tokenId)
          }
        }),
        _c("div", { staticClass: "head_info" }, [
          _c("div", { staticClass: "head__name" }, [
            _vm._v(_vm._s(_vm.token.tokenName)),
            _vm.token.gateInfo.name
              ? _c("div", { staticClass: "head__name__gate" })
              : _vm._e()
          ]),
          _c("div", { staticClass: "head__symbol" }, [
            _vm._v(_vm._s(_vm.token.tokenSymbol))
          ])
        ]),
        _vm.gateName
          ? _c("div", { staticClass: "gate_info" }, [
              _vm._v(_vm._s(_vm.gateName))
            ])
          : _vm._e()
      ]),
      _c("div", { staticClass: "tab" }, [
        _c(
          "div",
          {
            staticClass: "tab__item",
            class: { active: _vm.tabName === "tokenInfo" },
            on: {
              click: function($event) {
                return _vm.tabClick("tokenInfo")
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("tokenCard.tokenInfo.tabName")))]
        ),
        _vm.token.type !== "NATIVE"
          ? _c(
              "div",
              {
                staticClass: "tab__item",
                class: { active: _vm.tabName === "gate" },
                on: {
                  click: function($event) {
                    return _vm.tabClick("gate")
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("tokenCard.gateInfo.tabName")))]
            )
          : _vm._e(),
        _vm.token.type !== "NATIVE"
          ? _c(
              "div",
              {
                staticClass: "tab__item",
                class: { active: _vm.tabName === "deposit" },
                on: {
                  click: function($event) {
                    return _vm.tabClick("deposit")
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("tokenCard.depositRecord.tabName")))]
            )
          : _vm._e(),
        _vm.token.type !== "NATIVE"
          ? _c(
              "div",
              {
                staticClass: "tab__item",
                class: { active: _vm.tabName === "withdraw" },
                on: {
                  click: function($event) {
                    return _vm.tabClick("withdraw")
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("tokenCard.withdrawRecord.tabName")))]
            )
          : _vm._e()
      ]),
      _vm.tabName === "tokenInfo"
        ? _c("div", { staticClass: "tab-content" }, [
            _c("div", { staticClass: "content__item" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v(
                  _vm._s(_vm.$t("tokenCard.tokenInfo.labels.tokenName")) + ":"
                )
              ]),
              _c(
                "div",
                {
                  staticClass: "click-able",
                  on: { click: _vm.goToTokenDetail }
                },
                [
                  _vm._v(
                    _vm._s(_vm.tokenDetail.name) +
                      " (" +
                      _vm._s(_vm.tokenDetail.symbol) +
                      ")"
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "content__item" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v(
                  _vm._s(_vm.$t("tokenCard.tokenInfo.labels.tokenId")) + ":"
                )
              ]),
              _c(
                "div",
                {
                  staticClass: "click-able",
                  on: { click: _vm.goToTokenDetail }
                },
                [_vm._v(_vm._s(_vm.token.tokenId))]
              )
            ]),
            _c("div", { staticClass: "content__item" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v(
                  _vm._s(_vm.$t("tokenCard.tokenInfo.labels.overview")) + ":"
                )
              ]),
              _c("div", [
                _vm._v(_vm._s(_vm.getOverview(_vm.tokenDetail.overview))),
                _vm.tokenDetail.overview &&
                _vm.tokenDetail.overviewLink &&
                _vm.tokenDetail.overviewLink.length
                  ? _c(
                      "span",
                      {
                        staticClass: "click-able view-more",
                        on: {
                          click: function($event) {
                            return _vm.openUrl(_vm.tokenDetail.overviewLink[0])
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("tokenCard.tokenInfo.labels.viewmore"))
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ]),
            _c("div", { staticClass: "content__item" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.$t("tokenCard.tokenInfo.labels.total")) + ":")
              ]),
              _c("div", [
                _vm._v(_vm._s(_vm.tokenDetail.showTotalSupply || "--"))
              ])
            ]),
            _c("div", { staticClass: "content__item" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.$t("tokenCard.tokenInfo.labels.type")) + ":")
              ]),
              _c("div", { staticClass: "div" }, [
                _vm._v(_vm._s(_vm.tokenDetail.ttype || "--"))
              ])
            ]),
            _c("div", { staticClass: "content__item" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.$t("tokenCard.tokenInfo.labels.gate")) + ":")
              ]),
              _c(
                "div",
                {
                  staticClass: "click-able",
                  on: {
                    click: function($event) {
                      return _vm.openUrl(
                        _vm.tokenDetail.gateway
                          ? _vm.tokenDetail.gateway.website
                          : null
                      )
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.tokenDetail.gateway
                        ? _vm.tokenDetail.gateway.name || "--"
                        : "--"
                    )
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "content__item" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v(
                  _vm._s(_vm.$t("tokenCard.tokenInfo.labels.website")) + ":"
                )
              ]),
              !_vm.tokenDetail.websiteLink ||
              !_vm.tokenDetail.websiteLink.length
                ? _c("div", [_vm._v(_vm._s("--"))])
                : _c(
                    "div",
                    _vm._l(_vm.tokenDetail.websiteLink, function(link, i) {
                      return _c(
                        "span",
                        {
                          key: i,
                          staticClass: "click-able",
                          on: {
                            click: function($event) {
                              return _vm.openUrl(link)
                            }
                          }
                        },
                        [_vm._v(_vm._s(link || "--"))]
                      )
                    }),
                    0
                  )
            ]),
            _c("div", { staticClass: "content__item" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v(
                  _vm._s(_vm.$t("tokenCard.tokenInfo.labels.whitePaper")) + ":"
                )
              ]),
              !_vm.tokenDetail.whitepaperLink ||
              !_vm.tokenDetail.whitepaperLink.length
                ? _c("div", [_vm._v(_vm._s("--"))])
                : _c(
                    "div",
                    _vm._l(_vm.tokenDetail.whitepaperLink, function(link, i) {
                      return _c(
                        "span",
                        {
                          key: i,
                          staticClass: "click-able",
                          on: {
                            click: function($event) {
                              return _vm.openUrl(link)
                            }
                          }
                        },
                        [_vm._v(_vm._s(link || "--"))]
                      )
                    }),
                    0
                  )
            ]),
            _c("div", { staticClass: "content__item" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v(
                  _vm._s(_vm.$t("tokenCard.tokenInfo.labels.explorer")) + ":"
                )
              ]),
              !_vm.tokenDetail.explorerLink ||
              !_vm.tokenDetail.explorerLink.length
                ? _c("div", [_vm._v(_vm._s("--"))])
                : _c(
                    "div",
                    _vm._l(_vm.tokenDetail.explorerLink, function(link, i) {
                      return _c(
                        "span",
                        {
                          key: i,
                          staticClass: "click-able",
                          on: {
                            click: function($event) {
                              return _vm.openUrl(link)
                            }
                          }
                        },
                        [_vm._v(_vm._s(link || "--"))]
                      )
                    }),
                    0
                  )
            ]),
            _c("div", { staticClass: "content__item" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v(
                  _vm._s(_vm.$t("tokenCard.tokenInfo.labels.github")) + ":"
                )
              ]),
              !_vm.tokenDetail.githubLink || !_vm.tokenDetail.githubLink.length
                ? _c("div", [_vm._v(_vm._s("--"))])
                : _c(
                    "div",
                    _vm._l(_vm.tokenDetail.githubLink, function(link, i) {
                      return _c(
                        "span",
                        {
                          key: i,
                          staticClass: "click-able",
                          on: {
                            click: function($event) {
                              return _vm.openUrl(link)
                            }
                          }
                        },
                        [_vm._v(_vm._s(link || "--"))]
                      )
                    }),
                    0
                  )
            ]),
            _c("div", { staticClass: "content__item" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.$t("tokenCard.tokenInfo.labels.media")) + ":")
              ]),
              _c("div", [
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tokenDetail.facebookLink,
                      expression: "tokenDetail.facebookLink"
                    }
                  ],
                  staticClass: "media-icon",
                  attrs: { src: require("assets/imgs/facebook.svg") },
                  on: {
                    click: function($event) {
                      return _vm.openUrl(_vm.tokenDetail.facebookLink)
                    }
                  }
                }),
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tokenDetail.twitterLink,
                      expression: "tokenDetail.twitterLink"
                    }
                  ],
                  staticClass: "media-icon",
                  attrs: { src: require("assets/imgs/twitter.svg") },
                  on: {
                    click: function($event) {
                      return _vm.openUrl(_vm.tokenDetail.twitterLink)
                    }
                  }
                }),
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tokenDetail.telegramLink,
                      expression: "tokenDetail.telegramLink"
                    }
                  ],
                  staticClass: "media-icon",
                  attrs: { src: require("assets/imgs/telegram.svg") },
                  on: {
                    click: function($event) {
                      return _vm.openUrl(_vm.tokenDetail.telegramLink)
                    }
                  }
                })
              ])
            ])
          ])
        : _vm._e(),
      _vm.tabName === "gate"
        ? _c("div", { staticClass: "tab-content" }, [
            _vm.token.gateInfo.url
              ? _c("div", { staticClass: "content__item" }, [
                  _c("div", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("tokenCard.gateInfo.name")) + ":")
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.gateInfo.name))])
                ])
              : _vm._e(),
            _vm.token.gateInfo.url
              ? _c("div", { staticClass: "content__item" }, [
                  _c("div", { staticClass: "label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("tokenCard.gateInfo.officalNet")) + ":"
                    )
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "click-able",
                      on: {
                        click: function($event) {
                          return _vm.openUrl(_vm.gateInfo.websiteLink)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.gateInfo.websiteLink))]
                  )
                ])
              : _vm._e(),
            _vm.token.gateInfo.url
              ? _c("div", { staticClass: "content__item" }, [
                  _c("div", { staticClass: "label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("tokenCard.gateInfo.introduction")) + ":"
                    )
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.gateIntroduction))])
                ])
              : _vm._e(),
            _vm.token.gateInfo.url
              ? _c("div", { staticClass: "content__item" }, [
                  _c("div", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("tokenCard.gateInfo.customer")) + ":")
                  ]),
                  _vm.gateInfo.serviceSupport
                    ? _c(
                        "div",
                        {
                          staticClass: "click-able",
                          on: {
                            click: function($event) {
                              return _vm.openUrl(_vm.gateInfo.serviceSupport)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.gateSupport))]
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _vm.token.gateInfo.url
              ? _c("div", { staticClass: "content__item" }, [
                  _c("div", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("tokenCard.gateInfo.privacy")) + ":")
                  ]),
                  _vm.gatePolicy
                    ? _c(
                        "div",
                        {
                          staticClass: "click-able",
                          on: {
                            click: function($event) {
                              return _vm.openUrl(_vm.gatePolicy)
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("tokenCard.gateInfo.clickPrivacy", {
                                gate: _vm.gateInfo.name
                              })
                            )
                          )
                        ]
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            !_vm.token.gateInfo.url
              ? _c("div", { staticClass: "content__item" }, [
                  _c("div", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("tokenCard.gateInfo.nodeDesc")) + ":")
                  ]),
                  _c("div", [
                    _vm._v(_vm._s(_vm.$t("tokenCard.gateInfo.nodeDescStr")))
                  ])
                ])
              : _vm._e(),
            _vm.token.type === "OFFICAL_GATE"
              ? _c(
                  "div",
                  { staticClass: "content__item center" },
                  [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$t("tokenCard.gateInfo.setting")) + ":")
                    ]),
                    _c("viteInput", {
                      staticClass: "gate-url",
                      attrs: {
                        placeholder: _vm.$t(
                          "tokenCard.gateInfo.settingPlaceholder"
                        ),
                        disabled: true
                      },
                      model: {
                        value: _vm.url,
                        callback: function($$v) {
                          _vm.url = $$v
                        },
                        expression: "url"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.token.type !== "OFFICAL_GATE" && (_vm.url || _vm.canEditGateURL)
              ? _c(
                  "div",
                  { staticClass: "content__item center" },
                  [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$t("tokenCard.gateInfo.setting")) + ":")
                    ]),
                    _c("viteInput", {
                      staticClass: "gate-url",
                      attrs: {
                        placeholder: _vm.$t(
                          "tokenCard.gateInfo.settingPlaceholder"
                        ),
                        disabled: !_vm.canEditGateURL
                      },
                      model: {
                        value: _vm.url,
                        callback: function($$v) {
                          _vm.url = $$v
                        },
                        expression: "url"
                      }
                    }),
                    _vm.canEditGateURL
                      ? _c(
                          "div",
                          { staticClass: "btn", on: { click: _vm.save } },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("tokenCard.tokenInfo.saveGate"))
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm.tabName === "deposit"
        ? _c(
            "div",
            { staticClass: "tab-content no-padding" },
            [
              _c("Tb", {
                key: "deposit_" + _vm.token.tokenId,
                attrs: { type: "deposit", token: _vm.token }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.tabName === "withdraw"
        ? _c(
            "div",
            { staticClass: "tab-content no-padding" },
            [
              _c("Tb", {
                key: "withdraw_" + _vm.token.tokenId,
                attrs: { type: "withdraw", token: _vm.token }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.ShowBottom
        ? _c("div", { style: _vm.s.btnGroup }, [
            !!_vm.STxt
              ? _c(
                  "div",
                  {
                    style: [
                      _vm.s.btn,
                      _vm.BtnUnuse || _vm.btnUnuse ? _vm.s.unUse : undefined
                    ],
                    on: { click: _vm.rClick }
                  },
                  [_vm._v(_vm._s(_vm.STxt))]
                )
              : _vm._e(),
            !_vm.STxt
              ? _c(
                  "div",
                  { style: [_vm.s.lBtn, _vm.s.btn], on: { click: _vm.lClick } },
                  [_vm._v(_vm._s(_vm.LTxt))]
                )
              : _vm._e(),
            !_vm.STxt
              ? _c(
                  "div",
                  {
                    style: [
                      _vm.s.btn,
                      _vm.BtnUnuse || _vm.btnUnuse ? _vm.s.unUse : undefined
                    ],
                    on: { click: _vm.rClick }
                  },
                  [_vm._v(_vm._s(_vm.RTxt))]
                )
              : _vm._e()
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }